import { combineReducers } from 'redux'
import globalReducer from './globalReducer'
import sideBarReducer from './sideBarReducer'

export default combineReducers({
  globalReducer,
  sideBarReducer
})
